import React from "react";
import dict, { t } from "../../i18n/es-MX";

const baseInput =
    "w-full h-11 px-3 rounded-lg bg-slate-950 border focus:ring-2 outline-none text-sm transition";

export function fieldClasses(error) {
    return `${baseInput} ${
        error
            ? "border-red-500 focus:border-red-500 focus:ring-red-500/30"
            : "border-slate-700 focus:border-brand-orange focus:ring-brand-orange/40"
    }`;
}

export function ErrorText({ error }) {
    if (!error) return null;
    const msg = t(error);
    return (
        <div className="field-error text-xs text-red-300 mt-1" data-testid="field-error">
            {msg && msg !== error ? msg : dict.common.required}
        </div>
    );
}

export function Field({ label, htmlFor, required, error, hint, children, testid }) {
    return (
        <div data-testid={testid}>
            <label
                htmlFor={htmlFor}
                className="block text-xs uppercase tracking-wider text-slate-400 mb-1.5"
            >
                {label}
                {required && <span className="text-brand-orange ml-1">*</span>}
            </label>
            {children}
            {error ? (
                <ErrorText error={error} />
            ) : hint ? (
                <div className="text-xs text-slate-500 mt-1">{hint}</div>
            ) : null}
        </div>
    );
}

export function TextInput({ error, ...props }) {
    return <input type="text" className={fieldClasses(error)} {...props} />;
}

export function NumberInput({ error, ...props }) {
    return <input type="number" inputMode="decimal" className={fieldClasses(error)} {...props} />;
}

export function DateInput({ error, ...props }) {
    return <input type="date" className={fieldClasses(error)} {...props} />;
}

export function SelectInput({ error, options, children, ...props }) {
    return (
        <select className={fieldClasses(error)} {...props}>
            {children}
            {options?.map(({ value, label }) => (
                <option key={value} value={value}>
                    {label}
                </option>
            ))}
        </select>
    );
}

export function Textarea({ error, rows = 3, ...props }) {
    return (
        <textarea
            rows={rows}
            className={`${fieldClasses(error)} h-auto py-2 min-h-[80px]`}
            {...props}
        />
    );
}
